// User action Type
export const SET_LOGGEDIN_USER = "SET_LOGGEDIN_USER";
export const RESET_LOGGEDIN_USER = "RESET_LOGGEDIN_USER";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
